exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#block3 .article-blocks{overflow:hidden}#block3 .article-blocks p{width:90%;color:#222831;font-size:1.6em;line-height:24px;margin:0 auto 25px}#block3 figure{text-align:center;margin-top:0}@media (max-width:767px){#block3{flex-wrap:wrap}#block3 h2{text-align:left}#block3 h2:after{left:0;margin-left:0}#block3 .article-blocks p{width:100%;text-align:left!important}#block3 figure{flex-basis:100%}#block3 figure img{width:92%}}@media (max-width:640px){#block3{flex-wrap:wrap}#block3 figure{flex-basis:100%}#block3 figure img{width:92%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f581472","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/blocks/Block3.vue
// module id = 106
// module chunks = 0